<template>
  <v-row class="text-form pl-4 pr-3 mb-3 align-center">
    <v-col cols="2">
      <h6 class="pl-4 pt-2">
        {{ i18n.global.t('pages.operationOffices.form.allocatedWork.title') }}
      </h6>
    </v-col>
    <v-col cols="9">
      <v-row class="align-center">
        <v-col cols="1">
          <v-switch
            v-model="modelValue.is_active_allocated"
            color="blue"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-show="modelValue.is_active_allocated"
            :label="i18n.global.t('pages.operationOffices.form.allocatedWork.time')"
            v-model="modelValue.allocated_minute"
            :suffix="i18n.global.t('pages.operationOffices.form.allocatedWork.stoppingMoreThanMinutes')"
            class="mt-0"
            maxlength="5"
            hide-details="auto"
            :error-messages="errors['allocated_minute']"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-show="modelValue.is_active_allocated"
            :label="i18n.global.t('pages.operationOffices.form.allocatedWork.work')"
            :items="SELECTABLE_WORK_EVENT_TYPE"
            item-value="value"
            item-title="name"
            v-model="modelValue.allocated_work"
            hide-details="auto"
            :error-messages="errors['allocated_work']"
          ></v-select>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { SELECTABLE_WORK_EVENT_TYPE } from '@/services/consts/operation_office';
import { watch, computed } from 'vue'
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: {
    is_active_allocated: boolean,
    allocated_minute: number | null,
    allocated_work: string,
  }
  errors: { [key: string]: string[] }
  windowInnerWidth: number
}>()


const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

watch(() => props.modelValue.is_active_allocated, (newVal) => {
  if (!newVal) {
    modelValue.value.allocated_minute = null;
    modelValue.value.allocated_work = '';
  }
}, { deep: true })
</script>

<style>
.checkbox-with-number-text-form .v-input__details {
  display: none;
}
</style>
